const initialStateSignIn = {
  message: '',
  fetching : false,
  fetchingError: false,
  authenticated: false,
  checkedLocalStorage: false,
  showV2: false,
  recaptchaV2Selected: false,
  api: {
    signIn: {
      userId    : 0,
      userName  : '',
      token     : '',
      email     : '',
      companys  : []
    }
  },
  validation : {
    email           : false,
    emailFormat     : false,
    password        : false,
    passwordFormat  : false
  }
};

export default initialStateSignIn;